<div class="box card-box m-x-sm shadow">

  <div class="box-header" *ngIf="!hideTitle">
    <h3>{{'EMPLOYEE_MANAGE.pay_slips' | translate}}</h3>
  </div>

  <div class="box-body table-responsive">
    <gp-table class="table" (sortChange)="onSortKeyChange($event)">
      <thead gp-table-head>
      <tr role="row">
        <th class="column-title text-muted small" gp-table-column>
          <!--sort-key="contractPeriod" default-sort="asc"-->
          {{ 'EMPLOYEE_MANAGE.pay_period' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column>
          <!--sort-key="payTypeTransId"-->
          {{ 'EMPLOYEE_MANAGE.pay_type' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column>
          <!--sort-key="grossSalary"-->
          {{ 'EMPLOYEE_MANAGE.gross_salary' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column>
          <!--sort-key="empTaxes"-->
          {{ 'EMPLOYEE_MANAGE.employee_taxes_and_costs' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column>
          <!--sort-key="empTaxesAndCosts"-->
          {{ 'EMPLOYEE_MANAGE.company_taxes_and_costs' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column>
          <!--sort-key="netPay"-->
          {{ 'EMPLOYEE_MANAGE.net_pay' | translate }}
        </th>
        <th gp-table-column></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="loading">
        <td colspan="11" class="text-center p-t-lg p-b-lg">
          <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
        </td>
      </tr>
      <tr *ngFor="let paySlip of paySlips" [ngClass]="{'retro-opacity': isRetroPayslip(paySlip)}">
        <td test-id="pay-slip-pay-period">
          <sup *ngIf="isRetroPayslip(paySlip)" class="retroactivity-badge">&#9415; </sup>
          {{ paySlip.tags.payPeriodTransId | translate }}
          <span *ngIf="isRetroPayslip(paySlip)">({{paySlip.tags.originPayPeriodTransId | translate}})</span>
        </td>
        <td test-id="pay-slip-pay-type">
          {{ paySlip.tags.payTypeTransId | translate }}
        </td>
        <td test-id="pay-slip-gross-salary">
          {{ paySlip.tags.grossSalary }}
        </td>
        <td test-id="pay-slip-employee-taxes-and-costs">
          {{ paySlip.tags.employeeTaxesAndCosts }}
        </td>
        <td test-id="pay-slip-company-taxes-and-costs">
          {{ paySlip.tags.companyTaxesAndCosts }}
        </td>
        <td test-id="pay-slip-net-pay">
          {{ paySlip.tags.netPay }}
        </td>
        <td class="text-left disable-opacity">
          <span class="btn btn-xs btn-icon white download m-r-xs"
                (click)="downloadPayslip(paySlip.id)">
            <i aria-hidden="true" class="fa fa-light fa-download"
               tooltip="{{ 'TOOLTIPS.download' | translate }}">
            </i>
          </span>
          <span class="btn btn-xs btn-icon white"
                *ngIf="!isEssMode() && hasRetroPayslips(paySlip) && !paySlip.tags.isRetroDisplay"
                (click)="displayRetroPayslips(paySlip)">
            <i aria-hidden="true" class="fa fa-light fa-plus"
               tooltip="{{ 'TOOLTIPS.display_retro_payslips' | translate }}">
            </i>
          </span>
          <span class="btn btn-xs btn-icon white"
                *ngIf="!isEssMode() && hasRetroPayslips(paySlip) && paySlip.tags.isRetroDisplay"
                (click)="removeRetroPayslips(paySlip)">
            <i aria-hidden="true" class="fa fa-light fa-minus"
               tooltip="{{ 'TOOLTIPS.hide_retro_payslips' | translate }}">
            </i>
          </span>
        </td>
      </tr>
      </tbody>
    </gp-table>
    <div *ngIf="!loading && paySlips.length === 0">
      <gp-illustrated-message [text]="'EMPLOYEE_MANAGE.pay_slips_not_found'" [width]="'65%'"></gp-illustrated-message>
    </div>
  </div>

  <ng2-pdfjs-viewer #externalPayslipViewer [externalWindow]="true"></ng2-pdfjs-viewer>

  <footer class="dker p-a" gp-sticky="bottom">
    <div class="row">
      <div class="col-sm-12 text-center">
        <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
          <li class="page-item" [ngClass]="{disabled: !pagination.hasPrevious()}">
            <a class="page-link" (click)="pagination.hasPrevious() && pagination.first()"><i
              class="fa fa-light fa-angle-double-left"></i></a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasPrevious()}">
            <a class="page-link" (click)="pagination.hasPrevious() && pagination.previous()"><i
              class="fa fa-light fa-angle-left"></i></a>
          </li>
          <li *ngFor="let page of pagination.pages()" class="page-item"
              [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
            <a *ngIf="page > 0" class="page-link" (click)="pagination.goToPage(page - 1)">{{ page }}</a>
            <a *ngIf="page < 1" class="page-link default-cursor">…</a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasNext()}">
            <a class="page-link" (click)="pagination.hasNext() && pagination.next()"><i
              class="fa fa-light fa-angle-right"></i></a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasNext()}">
            <a class="page-link" (click)="pagination.hasNext() && pagination.last()"><i
              class="fa fa-light fa-angle-double-right"></i></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</div>
